module.exports = __webpack_public_path__ + "static/a07a05ccb786dd847f066274bdf111371108af797dbe07ddcf40298f481f6a42-2ddf5d196c27d6e173db52691f7bd6f2.png";